import axios from 'axios';
import store from '../store'
import router from '../router';
import {
    Message,
	MessageBox
} from 'element-ui';
import config from '@/api/config';
import qs from 'qs'
import {
    Base64
} from '@/utils/base64.js';

export const axiosInstance = axios.create({
    //baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    baseURL: config.baseUrl,
    timeout: 100000,
    withCredentials: true,
});

// 请求拦截
axiosInstance.interceptors.request.use(config => {
	// if(!localStorage.getItem('accessToken')&&!!store.state.accessToken){
	// 	MessageBox('localStorage缓存消失，state缓存存在,accessToken:'+store.state.accessToken)
	// }
    let accessToken = store.state.accessToken || localStorage.getItem('accessToken');
    let params = {};
    if (config.method == 'get') {
        if (config.params) {
            Object.keys(config.params).forEach((key) => {
                if (config.params[key] !== '') {
                    params[key] = config.params[key];
                }
            });
        }
        config.params = params;
    } else {
        if (config.data) {
            Object.keys(config.data).forEach((key) => {
                if (config.data[key] !== '') {
					//有功能需要空串参数删除数据，
					//但是接手人无法确定以前POST过滤空串参数的原因，为防止改动原逻辑导致可能存在的问题
					//只能通过‘null’标记添加空串参数
					if(config.data[key]==='null'){
						params[key] = '';
					} else {
						params[key] = config.data[key];
					}
                }
            });
        }
        config.data = params;
    }
    if (accessToken) {
        config.headers['Blade-Auth'] = 'bearer ' + accessToken;
    }
    config.headers['Tenant-Id'] = '000000';
    // 客户端认证参数
    config.headers['Authorization'] = 'Basic ' + Base64.encode('sword:sword_secret');
    return config

});

// 响应拦截器
axiosInstance.interceptors.response.use(response => {

    console.log('response', response)
    // 状态码200成功
    if (response.status === 200) {
        if(response.data.code==200){
            return Promise.resolve(response.data.data)
        }else{
            Message.error(response.data.msg)
            return Promise.reject(response);
        }


    } else if (response.status === 401) {
        //登录token失效 返回首页重新登录
        Message.error(response.data.msg)
        router.replace('/login').then(() => {
            return false
        })
		// router.replace({name:"login"})
    } else {
        //失败则提示失败信息,拦截请求响应
        if (response.data.error_code) {
            Message.error(response.data.error_description)
        } else {
            Message.error(response.data.msg)

        }
        return Promise.reject(response);
    }
}, error => {

    if (error.response.status === 401) {
        //登录token失效 返回首页重新登录
        store.commit('$uStore', {name: 'isLogin', value: false})
        store.commit('$uStore', {name: 'accessToken', value: ''})
        store.commit('$uStore', {name: 'refreshToken', value: ''})
        store.commit('$uStore', {name: 'userInfo', value: {}})
        // Message.error(error.response.data.msg)
		if(!store.state.hasAlert){
			store.commit('$uStore', {name: 'hasAlert', value: true})
			MessageBox.alert('当前用户未登录或已过期，请重新登录', '提示', {
			    confirmButtonText: '确定',
			    callback: action => {
			        // router.replace('/login').then(() => {
			        //     return false
			        // })
					router.replace({name:"login"})
			    }
			});
		}
    } else {
		Message.error(error.response.data.msg)
	}

    window.console.log(error)
    return Promise.reject(error.response)
});

export const LoginAxiosInstance = axios.create({
    //baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    baseURL: '/api',
    timeout: 100000,
    withCredentials: true,
});

// 请求拦截
LoginAxiosInstance.interceptors.request.use(config => {

    config.headers['Content-Type'] == 'application/x-www-form-urlencoded'
    config.headers['Tenant-Id'] = '000000';
    config.data = qs.stringify(config.data)
    // 客户端认证参数
    config.headers['Authorization'] = 'Basic ' + Base64.encode('sword:sword_secret');
    return config
});

// 响应拦截器
LoginAxiosInstance.interceptors.response.use(response => {

    console.log(response)

    if (response.status == 200) {

        if (response.data.error_code) {
            Message.error(response.data.error_description)
            return Promise.reject(response.data)
        } else {
            if(response.data.code&&response.data.code!=200){
                Message.error(response.data.msg)
                return Promise.reject(response);
            }
            return Promise.resolve(response.data)
        }
    }
    return Promise.reject(res)
}, error => {
    if (error.response.status === 401) {
        MessageBox.alert('当前用户已过期，请重新登录', '提示', {
            confirmButtonText: '确定',
            callback: action => {
                // router.replace('/login').then(() => {
                //     return false
                // })
				router.replace({name:"login"})
            }
        });
    } else {
		Message.error(error.response.data.msg)
	}
    window.console.log(error)
    return Promise.reject(error.response)
});
